import { useField } from "formik";
import React from "react";
import { Dropdown, Form, Label } from "semantic-ui-react";

const retentionMarks = [
  {
    key: "awaiting-response",
    value: "awaiting-response",
    text: "Awaiting Response",
  },
  { key: "accepted", value: "accepted", text: "Accepted" },
  {
    key: "date-change-requested",
    value: "date-change-requested",
    text: "Date Change Requested",
  },
  { key: "activated", value: "activated", text: "Activated" },
  { key: "cancelled", value: "cancelled", text: "Cancelled" },
  { key: "rejected", value: "rejected", text: "Rejected" },
  { key: "pov", value: "pov", text: "Pre-Order Validation" },
  { key: "provisioned", value: "provisioned", text: "Provisioned" },
];

const SubmissionStatusSelect = ({ label, ...props }: any) => {
  const [field, meta, helpers] = useField(props);

  return (
    <Form.Field>
      <label>{label}</label>
      <Dropdown
        name={field.name}
        defaultValue={field.value}
        fluid
        search
        selection
        options={retentionMarks}
        placeholder='Select Status Type'
        onChange={(event, { value }) => {
          helpers.setValue(value);
        }}
      />
      {meta.error && (
        <Label basic color='red' pointing>
          {meta.error}
        </Label>
      )}
    </Form.Field>
  );
};

export default SubmissionStatusSelect;
